// Pure helpers for the /tools full list (no React): the catalog payload in, what each category shows out.
// Rule (Nitish, Nov 3 2026, the same rule as the in-app Connectors fix): a category PREVIEW skips the page's featured apps
// and refills to PREVIEW_SIZE; its count, "Show all" and search keep every app.

export const PREVIEW_SIZE = 8;

const byName = (a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }) || a.slug.localeCompare(b.slug);

/** Apps per category id, each list in showcase order (featured, then popular, from the server), then by name. */
export const groupByCategory = (catalog) => {
  const out = {};
  const showcase = {};
  (catalog?.categories || []).forEach((c) => {
    out[c.id] = [];
    showcase[c.id] = c.showcase || [];
  });
  (catalog?.apps || []).forEach((a) => (a.categories || []).forEach((id) => out[id] && out[id].push(a)));
  Object.keys(out).forEach((id) => {
    const rank = new Map(showcase[id].map((s, i) => [s, i]));
    out[id].sort((a, b) => {
      const ra = rank.has(a.slug) ? rank.get(a.slug) : Infinity;
      const rb = rank.has(b.slug) ? rank.get(b.slug) : Infinity;
      return ra !== rb ? ra - rb : byName(a, b);
    });
  });
  return out;
};

/** The category preview: skip `skip` (the featured slugs), refill to PREVIEW_SIZE. */
export const previewFor = (apps, skip) => (apps || []).filter((a) => !skip.has(a.slug)).slice(0, PREVIEW_SIZE);

/** Every app whose name contains the query (case-insensitive), by name. '' = no search. */
export const searchApps = (catalog, query) => {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return [];
  return (catalog?.apps || []).filter((a) => a.name.toLowerCase().includes(q)).sort(byName);
};

/** Category id -> live count from the payload. */
export const countsById = (catalog) =>
  Object.fromEntries((catalog?.categories || []).map((c) => [c.id, c.count]));
